import { render, staticRenderFns } from "./TagLine.vue?vue&type=template&id=b8535878&scoped=true"
import script from "./TagLine.vue?vue&type=script&lang=js"
export * from "./TagLine.vue?vue&type=script&lang=js"
import style0 from "./TagLine.vue?vue&type=style&index=0&id=b8535878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8535878",
  null
  
)

export default component.exports